<template>
  <div class="sidebar-block-wrapper">
    <header :class="[ headerBetween && 'justify-between', $slots.body && 'mb-2' ]">
      <slot v-if="$slots.header" name="header" />
    </header>
    <div class="body" v-if="$slots.body">
      <slot name="body"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "SidebarBlock",
  props: {
    headerBetween: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/tournament-form-tokens";

.sidebar-block-wrapper::v-deep {
  @include tf-tokens-light;

  * { margin: 0; }

  /* подпись блока */
  .block-name {
    display: block;
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: .07em;
    text-transform: uppercase;
    color: var(--tf-muted);

    &.right { text-align: right; }
  }

  .tournament-title {
    margin-top: 3px;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.3;
    color: var(--tf-text-strong);
    word-break: break-word;
  }

  header {
    &.justify-between {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
    }

    /* кнопка действия блока: «Создать этап», «Создать группу», «Завершить» */
    .action-button {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      flex: 0 0 auto;
      height: 28px;
      padding: 0 12px;
      border: 1px solid var(--tf-primary);
      border-radius: 9px;
      background: var(--tf-primary-soft);
      color: var(--tf-primary);
      font-size: 11.5px;
      font-weight: 600;
      white-space: nowrap;
      transition: background .16s ease, color .16s ease;

      &:hover { background: var(--tf-primary); color: #fff; }
    }
  }
}

body.dark-only .sidebar-block-wrapper::v-deep {
  @include tf-tokens-dark;
}
</style>